/* /assets/ctr-featured-recipes.js */

(function () {
  function initSection(section) {
    initDesktopSlider(section);
    initMobileSwiper(section);
  }

  function initDesktopSlider(section) {
    var slider = section.querySelector('.ctr-featured-recipes__desktop-slider');
    if (!slider) return;

    var pages = slider.querySelectorAll('.ctr-featured-recipes__page');
    var dots = slider.querySelectorAll('.ctr-featured-recipes__dot');
    var prevBtn = slider.querySelector('.ctr-featured-recipes__nav-prev');
    var nextBtn = slider.querySelector('.ctr-featured-recipes__nav-next');
    var currentPage = 0;
    var totalPages = pages.length;

    if (totalPages <= 1) return;

    function updateNavState() {
      if (prevBtn) {
        prevBtn.disabled = currentPage === 0;
        prevBtn.classList.toggle('ctr-featured-recipes__nav-btn--disabled', currentPage === 0);
      }
      if (nextBtn) {
        nextBtn.disabled = currentPage >= totalPages - 1;
        nextBtn.classList.toggle('ctr-featured-recipes__nav-btn--disabled', currentPage >= totalPages - 1);
      }
    }

    function goToPage(index) {
      if (index < 0 || index >= totalPages) return;
      pages.forEach(function (p) {
        p.classList.remove('ctr-featured-recipes__page--active');
      });
      dots.forEach(function (d) {
        d.classList.remove('ctr-featured-recipes__dot--active');
      });
      pages[index].classList.add('ctr-featured-recipes__page--active');
      if (dots[index]) dots[index].classList.add('ctr-featured-recipes__dot--active');
      currentPage = index;
      updateNavState();
    }

    updateNavState();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToPage(currentPage - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToPage(currentPage + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToPage(parseInt(dot.dataset.dot, 10));
      });
    });
  }

  function initMobileSwiper(section) {
    if (typeof Swiper === 'undefined') return;

    var swiperEl = section.querySelector('.ctr-featured-recipes__swiper-mobile');
    if (!swiperEl) return;

    var paginationEl = section.querySelector('.ctr-featured-recipes__mobile-pagination');
    var prevBtn = section.querySelector('.ctr-featured-recipes__mobile-prev');
    var nextBtn = section.querySelector('.ctr-featured-recipes__mobile-next');

    new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      pagination: {
        el: paginationEl,
        clickable: true,
        bulletClass: 'ctr-featured-recipes__dot',
        bulletActiveClass: 'ctr-featured-recipes__dot--active'
      },
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'ctr-featured-recipes__nav-btn--disabled'
      }
    });
  }

  function setup() {
    document.querySelectorAll('[data-section-type="ctr-featured-recipes"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-section-type="ctr-featured-recipes"]');
      if (section) initSection(section);
    });
  }
})();
